<template>
    <div>
        <div class="isTips" v-show="tipShow">正在请求...</div>
        <div class="nolist" v-show="!hasmsg">
            <img src="@/assets/nomsg.png" alt="">
            没有任何挂单
            <p @click="loads">去交易</p>
        </div>
        <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
        <!-- 网络异常tips -->
        <div class="tips" v-show="this.$store.state.tips"><span>网络异常！请检查网络设置或下拉刷新</span></div>
        <div class="mask" v-show="chedanShow"></div>
        <div ref="directrecordwp" class="list" v-show="hasmsg">

            <div class="list-item" v-for="(item,index) of arrlist" :key="index">
                <div class="water-mark" v-show="mnwatermark">模拟</div>
                <div class="title">
                    <span :style="{backgroundColor:item.orderDirection == 2 || item.orderDirection == 6?'#FF4F36':(item.orderDirection == 3 || item.orderDirection == 7?'#17CF84':(item.orderDirection == 4?'#FF4F36':(item.orderDirection == 5?'#17CF84':'#999999')))}">{{item.orderDirection == 2?'限价买入':(item.orderDirection == 3?'限价卖出':(item.orderDirection == 4?'止损买入':(item.orderDirection == 5?'止损卖出':(item.orderDirection == 6?'停损限价买入':(item.orderDirection == 7?'停损限价卖出':(item.orderDirection == 0?'买入':(item.orderDirection == 1?'卖出':'')))))))}}</span>
                    <span>{{item.symbol == 'XAU' || item.symbol == 'GOLD'?'伦敦金':(item.symbol == 'XAG' || item.symbol == 'SILVER'?'伦敦银':'未知')}} {{item.lots.toFixed(2)}}手</span>
                    <span class="time">{{getTime(item.openTime)}}</span>
                </div>
                <ul>
                    <li>
                        <div class="left">
                            <p>订单<span>{{item.ticket}}</span></p>
                            <p>挂单<span>{{item.symbol == 'XAU' || item.symbol == 'GOLD'?item.openPrice.toFixed(2):(item.symbol == 'XAG' || item.symbol == 'SILVER'?item.openPrice.toFixed(3):item.openPrice)}}</span></p>
                            <p>最新<span>{{getNewPrice(index)}}</span></p>
                            <p v-show="Number(item.stopLimit)">停损限价<span>{{item.symbol == 'XAU' || item.symbol == 'GOLD'?parseFloat(item.stopLimit).toFixed(2):(item.symbol == "XAG" || item.symbol == "SILVER"?parseFloat(item.stopLimit).toFixed(3):"")}}</span></p>
                        </div>
                        <div class="right">
                            <p>有效期<span>{{item.expiration == 0?'长期有效':getTime(item.expiration)}}</span></p>
                            <p>止损<span>{{item.stopLoss!==0 && (item.symbol == 'XAU' || item.symbol == 'GOLD')?item.stopLoss.toFixed(2):(item.stopLoss!==0 && (item.symbol == 'XAG' || item.symbol == 'SILVER')?item.stopLoss.toFixed(3):'未设置')}}</span></p>
                            <p>止盈<span>{{item.takeProfit!==0 && (item.symbol == 'XAU' || item.symbol == 'GOLD')?parseFloat(item.takeProfit).toFixed(2):(item.takeProfit!==0 && (item.symbol == 'XAG' || item.symbol == 'SILVER')?parseFloat(item.takeProfit).toFixed(3):'未设置')}}</span></p>
                        </div>
                    </li>
                    <div class="btn">
                        <div @click="handleXiugai(index)">修改</div>
                        <div @click="handledan(index)">撤单</div>
                    </div>
                </ul>

                <!-- 撤销订单确认框 -->
                <div class="confirmbox" v-show="selectset == index">
                    <div class="title">撤销挂单</div>
                    <p>是否撤销该挂单?</p>
                    <ul>
                        <li @click="removeConfirmbox()">取消</li>
                        <li v-preventReClick @click="handleChe(index)">确认</li>
                    </ul>
                </div>

            </div>
        </div>
    </mescroll-vue>
    </div>
</template>

<script>
import pako from 'pako'
import MescrollVue from 'mescroll.js/mescroll.vue'
import Watermark from '@/utils/watermark'
import {allPendingOrder,handleChedan,stopsLevelXAU,stopsLevelXAG,utf8ByteToUnicodeStr} from '@/utils/socket2.js';
import {mapState,mapMutations,mapAction,mapGetters} from 'vuex'
import revisepages from '@/components/revisepage'
import { Message } from 'element-ui';
export default {
    inject:['reload'], //注入刷新当前页依赖 来自app.vue
    name:"pendingOrders",
    components:{
        revisepages,
		MescrollVue // 注册mescroll组件
    },
    data(){
        return{
            arrlist:[],
            mnwatermark:false,//水印
            Chedan:false,//撤单开关
            hasmsg:false, //没有任何订单
            chedanShow:false, //撤单弹出框
            tipShow:false,//请求tips

            selectset:-1,

            mescroll: null, // mescroll实例对象
			mescrollDown:{
                auto:false,
                callback:this.downCallback
            }, //下拉刷新的配置. (如果下拉刷新和上拉加载处理的逻辑是一样的,则mescrollDown可不用写了)
			mescrollUp: { // 上拉加载的配置.
                use:false,
                auto:false,
			},
        }
    },
    methods:{

        // mescroll组件初始化的回调,可获取到mescroll对象
		mescrollInit (mescroll) {
			this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
		},

        downCallback (mescroll) {

            setTimeout(() => {

                this.reload();

            }, 1000)

	    },

        NumberAdd(arg1, arg2){
            var r1,r2,m,n
            try{
                r1 = arg1.toString().split('.')[1].length
            } catch (e){
                r1 = 0
            }
            try{
                r2 = arg2.toString().split('.')[1].length
            } catch (e){
                r2 = 0
            }
            m = Math.pow(10, Math.max(r1, r2))
            n = ( r1 >= r2 ) ? r1 : r2
            return ((arg1 * m + arg2 * m ) / m ).toFixed(n)
        },

        Sub(arg1, arg2) {
            arg1 = parseFloat(arg1);
            arg2 = parseFloat(arg2);
            var r1, r2, m, n;
            try {
                r1 = arg1.toString().split(".")[1].length
            } catch (e) {
                r1 = 0
            }
            try {
                r2 = arg2.toString().split(".")[1].length
            } catch (e) {
                r2 = 0
            }
            m = Math.pow(10, Math.max(r1, r2));
            //动态控制精度长度
            n = (r1 >= r2) ? r1 : r2;
            return ((arg1 * m - arg2 * m ) / m ).toFixed(n)
        },

        // 点击修改撤单
        handleXiugai(index){
            
            //把修改撤单页面需要的信息储存到vuex
            this.$store.state.orderDirection = this.arrlist[index].orderDirection
            this.$store.state.ticket = this.arrlist[index].ticket
            this.$store.state.openTime = this.arrlist[index].openTime
            this.$store.state.symbol = this.arrlist[index].symbol
            this.$store.state.lots = this.arrlist[index].lots
            this.$store.state.openPrice = this.arrlist[index].symbol == 'XAU' || this.arrlist[index].symbol == 'GOLD'?(this.arrlist[index].openPrice).toFixed(2):(this.arrlist[index].openPrice).toFixed(3) //专业投资者与非专业投资者
            // this.$store.state.openPrice = this.arrlist[index].symbol == 'GOLD'?parseFloat(this.arrlist[index].openPrice).toFixed(2):parseFloat(this.arrlist[index].openPrice).toFixed(3) //非专业投资者
            this.$store.state.news = this.getNewPrice(index)
            this.$store.state.expiration = this.arrlist[index].expiration
            this.$store.state.stopLoss = this.arrlist[index].symbol == 'XAU' || this.arrlist[index].symbol == 'GOLD'?(this.arrlist[index].stopLoss).toFixed(2):(this.arrlist[index].stopLoss).toFixed(3)
            this.$store.state.takeProfit = this.arrlist[index].symbol == 'XAU' || this.arrlist[index].symbol == 'GOLD'?(this.arrlist[index].takeProfit).toFixed(2):this.arrlist[index].takeProfit.toFixed(3)

            this.$store.state.stopLimit = this.arrlist[index].symbol == 'XAU' || this.arrlist[index].symbol == 'GOLD'?Number(this.arrlist[index].stopLimit).toFixed(2):Number(this.arrlist[index].stopLimit).toFixed(3)

            // 跳转之前判断是否黄金 专业投资者
            if(this.arrlist[index].symbol == 'XAU'){
               this.$store.state.getisgold = true 
            }else if(this.arrlist[index].symbol == 'XAG'){
                this.$store.state.getisgold = false
            }

            // 跳转之前判断是否黄金 非专业投资者
            if(this.arrlist[index].symbol == 'GOLD'){
               this.$store.state.getisgold = true 
            }else if(this.arrlist[index].symbol == 'SILVER'){
                this.$store.state.getisgold = false
            }

            if(this.$store.state.getisgold){
                if(this.$store.state.orderDirection == 2){
                    this.$store.state.news = '<' + (Number(this.$store.state.news - (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))
                }else if(this.$store.state.orderDirection == 3){
                    this.$store.state.news =  '>' + (Number(this.$store.state.news + (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))
                }else if(this.$store.state.orderDirection == 4){
                    this.$store.state.news =  '>' + (Number(this.$store.state.news + (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))
                }else if(this.$store.state.orderDirection == 5){
                    this.$store.state.news =  '<' + (Number(this.$store.state.news - (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))
                }else if(this.$store.state.orderDirection == 6){
                    this.$store.state.news = ">" + (Number(this.$store.state.news) + (this.$store.state.goldstopsLevel * 0.01)).toFixed(2)
                }else if(this.$store.state.orderDirection == 7){
                    this.$store.state.news = "<" + (Number(this.$store.state.news) - (this.$store.state.goldstopsLevel * 0.01)).toFixed(2)
                }
            }else if(!this.$store.state.getisgold){
                if(this.$store.state.news && this.$store.state.orderDirection == 2){
                    this.$store.state.news = '<' + (Number(this.Sub(this.$store.state.news,(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))
                }else if(this.$store.state.news && this.$store.state.orderDirection == 3){
                    this.$store.state.news = '>' + (Number(this.NumberAdd(this.$store.state.news,(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))
                }else if(this.$store.state.news && this.$store.state.orderDirection == 4){
                    this.$store.state.news = '>' + (Number(this.NumberAdd(this.$store.state.news,(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))
                }else if(this.$store.state.news && this.$store.state.orderDirection == 5){
                    this.$store.state.news = '<' + (Number(this.Sub(this.$store.state.news,(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))
                }else if(this.$store.state.orderDirection == 6){
                    this.$store.state.news = ">" + (Number(this.$store.state.news) + (this.$store.state.silverstopsLevel * 0.001)).toFixed(3)
                }else if(this.$store.state.orderDirection == 7){
                    this.$store.state.news = "<" + (Number(this.$store.state.news) - (this.$store.state.silverstopsLevel * 0.001)).toFixed(3)
                }
            }

            this.$router.push({path:'/revisepage'})

        },

        // 撤单
        handleChe(index){
 
            var that = this

            that.global.ws.onmessage = this.onmessage

            that.Chedan = true
            if (that.global.ws && that.global.ws.readyState == 1 && that.Chedan) {

                handleChedan(that.arrlist[index].ticket,that.global.ws)
                that.tipShow = true //请求提示开启
            }
        },

        initWebpack(){

            var that = this
            
            that.removeConfirmbox()

            if (that.global.ws && that.global.ws.readyState == 1) {

                allPendingOrder(that.global.ws)
                
                stopsLevelXAU(that.global.ws,that.$store.state.dealgold) //获取专业投资者与非专业投资者挂单距离
            }

            that.global.ws.onmessage = this.onmessage


        },

        onmessage(evt){

            var data = atob(evt.data);
            var data2 = pako.inflateRaw(data);
            var arr = new Uint16Array(data2);
            var strData   = utf8ByteToUnicodeStr(arr);
            var obj = JSON.parse(strData)
 

            // 获取黄金挂单距离
            if(obj.act == 'get_stop_level'){
   
                if(obj.success == true){
                    this.$store.state.stopsLevel = obj.data.stopsLevel
                }
            }

            // 所有挂单信息处理
            if(obj.act == 'get_pend_orders'){
                if(obj.arr){

                    obj.arr.sort(function(a, b) {
                        let aTimeString = a['openTime']
                        let bTimeString = b['openTime']
                        let aTime = new Date(aTimeString).getTime()
                        let bTime = new Date(bTimeString).getTime()
                        return aTime - bTime
                    });
                    
                    this.arrlist = obj.arr

   
                    this.hasmsg = true //提示无订单关闭
                }else if(!obj.arr){
                    this.hasmsg = false //提示无订单开启
                }
                
                this.tipShow = false

                this.$emit('guadanlength',this.arrlist.length)
            }

            // 撤销挂单信息处理
            if(this.Chedan){
 
                if(obj.success){
                    this.Chedan = false //撤单开关关闭
                    this.chedanShow = false //关闭蒙层
                    this.$toast('撤单成功')
                    this.selectset = -1
                    this.tipShow = false
                    this.initWebpack()
                    // this.reload() //刷新当前页
                }else{
                    this.Chedan = false //撤单开关关闭
                    this.chedanShow = false //关闭蒙层
                    this.selectset = -1
                    this.tipShow = false //请求提示关闭
                    this.$toast(obj.msg)
                }
            }

            if(obj.act == 'order_update'){

                allPendingOrder(this.global.ws)
                stopsLevelXAU(this.global.ws,this.$store.state.dealgold)

                if(this.$store.state.login){

                    this.$store.state.ordertipshow = true
                    
                    this.$store.state.ordertype = obj.msg.replace(/[0-9]/g,"")

                    this.$store.state.orderticket = obj.msg.replace(/[^\d.]/g,"");
                    this.$store.state.ordersymbol = obj.data.symbol
                    this.$store.state.orderdeal = obj.data.orderDirection
                    this.$store.state.orderopenprice = obj.data.openPrice
                    this.$store.state.ordercloseprice = obj.data.closePrice
                    this.$store.state.orderlots = obj.data.lots
                    this.$store.state.orderopentime = obj.data.openTime
                    this.$store.state.orderclosetime = obj.data.closeTime

                    setTimeout(() => {

                        this.$store.state.ordertipshow = false

                    }, 5000)
                }

            }

        },

        // 计算最新价
        getNewPrice(index){

            // 如果是黄金 专业投资者
            if(this.arrlist[index].symbol == 'XAU' && this.arrlist[index].orderDirection == 2){
                return this.getGoldBuy.toFixed(2)
            }else if(this.arrlist[index].symbol == 'XAU' && this.arrlist[index].orderDirection == 3){
                return this.getGoldSell.toFixed(2)
            }else if(this.arrlist[index].symbol == 'XAU' && this.arrlist[index].orderDirection == 4){
                return this.getGoldBuy.toFixed(2)
            }else if(this.arrlist[index].symbol == 'XAU' && this.arrlist[index].orderDirection == 5){
                return this.getGoldSell.toFixed(2)
            }else if(this.arrlist[index].symbol == 'XAU' && this.arrlist[index].orderDirection == 6){
                return this.getGoldBuy.toFixed(2)
            }else if(this.arrlist[index].symbol == 'XAU' && this.arrlist[index].orderDirection == 7){
                return this.getGoldSell.toFixed(2)
            }

            // 如果是白银 专业投资者
            if(this.arrlist[index].symbol == 'XAG' && this.arrlist[index].orderDirection == 2){
                return this.getSilverBuy.toFixed(3)
            }else if(this.arrlist[index].symbol == 'XAG' && this.arrlist[index].orderDirection == 3){
                return this.getSilverSell.toFixed(3)
            }else if(this.arrlist[index].symbol == 'XAG' && this.arrlist[index].orderDirection == 4){
                return this.getSilverBuy.toFixed(3)
            }else if(this.arrlist[index].symbol == 'XAG' && this.arrlist[index].orderDirection == 5){
                return this.getSilverSell.toFixed(3)
            }else if(this.arrlist[index].symbol == 'XAG' && this.arrlist[index].orderDirection == 6){
                return this.getSilverBuy.toFixed(3)
            }else if(this.arrlist[index].symbol == 'XAG' && this.arrlist[index].orderDirection == 7){
                return this.getSilverSell.toFixed(3)
            }


            // 如果是黄金 非专业投资者
            if(this.arrlist[index].symbol == 'GOLD' && this.arrlist[index].orderDirection == 2){
                return this.getGoldBuy.toFixed(2)
            }else if(this.arrlist[index].symbol == 'GOLD' && this.arrlist[index].orderDirection == 3){
                return this.getGoldSell.toFixed(2)
            }else if(this.arrlist[index].symbol == 'GOLD' && this.arrlist[index].orderDirection == 4){
                return this.getGoldBuy.toFixed(2)
            }else if(this.arrlist[index].symbol == 'GOLD' && this.arrlist[index].orderDirection == 5){
                return this.getGoldSell.toFixed(2)
            }else if(this.arrlist[index].symbol == 'GOLD' && this.arrlist[index].orderDirection == 6){
                return this.getGoldBuy.toFixed(2)
            }else if(this.arrlist[index].symbol == 'GOLD' && this.arrlist[index].orderDirection == 7){
                return this.getGoldSell.toFixed(2)
            }

            // 如果是白银 非专业投资者
            if(this.arrlist[index].symbol == 'SILVER' && this.arrlist[index].orderDirection == 2){
                return this.getSilverBuy.toFixed(3)
            }else if(this.arrlist[index].symbol == 'SILVER' && this.arrlist[index].orderDirection == 3){
                return this.getSilverSell.toFixed(3)
            }else if(this.arrlist[index].symbol == 'SILVER' && this.arrlist[index].orderDirection == 4){
                return this.getSilverBuy.toFixed(3)
            }else if(this.arrlist[index].symbol == 'SILVER' && this.arrlist[index].orderDirection == 5){
                return this.getSilverSell.toFixed(3)
            }else if(this.arrlist[index].symbol == 'SILVER' && this.arrlist[index].orderDirection == 6){
                return this.getSilverBuy.toFixed(3)
            }else if(this.arrlist[index].symbol == 'SILVER' && this.arrlist[index].orderDirection == 7){
                return this.getSilverSell.toFixed(3)
            }

        },

        //撤单弹框
        handledan(index){
            this.selectset = this.selectset == index?-1:index
            this.chedanShow = true //打开蒙层
        },

        // 取消撤销挂单
        removeConfirmbox(){
            this.selectset = -1
            this.chedanShow = false //关闭蒙层
        },

        // 刷新当前页面
        loads(){
            this.$router.push({path:'deal'})
        },

        // 监听网络状态
        updateOnlineStatus(e) {
            const { type } = e;
            if(this.onLine = type === 'online'){
                this.$store.state.tips = false
                // this.reload() //重新连接网络之后刷新
            }else{
                this.$store.state.tips = true
            }
        },
        // 销毁时解除事件监听
        beforeDestroy(){
            window.removeEventListener('online',  this.updateOnlineStatus);
            window.removeEventListener('offline', this.updateOnlineStatus);
        },

        

    },

    watch: {
        $route(to, from) {
            if(to.fullPath == "/pending-order" &&  from.fullPath == "/deal"){
                //重新获取数据
                this.initWebpack()
            }
        }
    },
    computed:{

        // 获取黄金买入行情价
        getGoldBuy(){
            return this.$store.state.goldBuy
        },

        // 获取黄金卖出行情价
        getGoldSell(){
            return this.$store.state.goldSell
        },

        // 获取白银买入价
        getSilverBuy(){
            return this.$store.state.silverBuy
        },
        
        // 获取白银卖出价
        getSilverSell(){
            return this.$store.state.silverSell
        },
        
    },

    mounted(){
        this.initWebpack()
        // 加水印
        if(this.$store.state.mnlogin){
            this.mnwatermark = true
        }else{
            this.mnwatermark = false
        }

        // 禁止浏览器自带返回
        history.pushState(null, null, document.URL);
        window.addEventListener('popstate', function () {
            history.pushState(null, null, document.URL);
        });

        // this.$store.state.goldindex = true //必须，返回到交易页面由于是黄金页面所以必须重置为true，避免input黄金白银资金错乱


        window.addEventListener('online',  this.updateOnlineStatus);// 网络由异常到正常时触发
 
		window.addEventListener('offline', this.updateOnlineStatus);// 网络由正常常到异常时触发
    }
}
</script>

<style scoped>
    body{touch-action: none;}
    li{list-style: none;}

    /* 断网提示 */
    .tips{padding: 9.33px 12px 10px 12px;display: flex;align-items: center;justify-content: space-between;align-items: center;border-radius: 6px;background-color: #FFF5F3;color: #FF4F36;}
    .tips span:nth-of-type(1){padding-left: 11.67px;}
    .tips span:nth-of-type(2){padding-right: 11.33px;}

    /* 水印 */
    .water-mark{color:rgba(200, 200, 200, 0.80);font-size: 30px;position: absolute;bottom: 60px;right: 50px;}

    .isTips{width: 100px;height: 60px;border-radius: 9px;background: rgba(0, 0, 0, 0.6);position: fixed;left: 0;right: 0;top: 40%;z-index: 888;color: #FFFFFF;font-weight: bold;font-size: 14px;text-align: center;line-height: 60px;margin: 0 auto;}
    .mask{background: #000000;width: 100%;height: 100%;opacity: 0.5;position: fixed;left: 0;top: 0;z-index: 887;}
    .nolist{color: #999999;font-size:14px;text-align: center;position: fixed;left: 0;right: 0;top: 30%;z-index: 886;}
    .nolist img{width: 240ox;height: 120px;margin: 0 auto;display: block;}
    .nolist p{border-radius: 20px;color: #FFFFFF;display: flex;justify-content: center;align-items: center;background-image: linear-gradient(to right, #FF6738, #FF4F36);height: 34px;width: 60px;margin: 15px auto;}
    .list{margin: 0 auto;padding: 10px 12px 20px 12px;}
    .list-item{background-color: #FFFFFF;border-radius: 12px;margin-top: 10px;position: relative;}
    .list-item .title{padding: 12px 12px 0 12px;display: flex;align-items: center;}
    .list-item .title span:nth-of-type(1){padding: 3.33px 6.67px; height: 18px;border-radius: 12px;background-color: #17CF84;display: flex;justify-content: center;align-items: center;color: #FFFFFF;font-size: 12px;}
    .list-item .title span:nth-of-type(2){color: #333333;font-size: 16px;font-weight: bold;padding-left: 6px;}
    .list-item .title span:nth-of-type(3){color: #BBBBBB;font-size: 12px;text-align: right;flex: 1;text-align: right;}
    .list-item ul{padding: 0 12px 19.33px 12px; display: flex;justify-content: flex-start;align-items: center;flex-wrap: wrap;position: relative;}
    .list-item ul li{display: flex;flex-wrap: wrap;}
    .list-item ul li p{padding-top: 12px;}
    .list-item ul li .left{color: #999999;font-size: 14px;}
    .list-item ul li .right{padding-left: 15px;color: #999999;font-size: 14px;}
    .list-item ul li .left span{padding-left: 8.67px;color: #333333;font-size: 14px;}
    .list-item ul li .right span{padding-left: 8.67px;color: #333333;font-size: 14px;}

    .btn{width: 106px;height: 32px;display: flex;justify-content: space-between;align-items: center;position: absolute;right: 12px;bottom: 19.33px;}

    @media screen and (max-width: 320px) {
        .btn{flex-direction: column;right: 0px;bottom: 40.33px;}
        .btn div:nth-of-type(1){margin-bottom: 10px;}
        .water-mark{bottom:10px;right: 95px;font-size: 25px;}
    }

    .btn div{width: 50px;height: 100%; border-radius: 16px;display: flex;justify-content: center;align-items: center;}
    .btn div:nth-of-type(1){border: 1px solid #BBBBBB;background-color: #FFFFFF;color: #FF4F36;font-size: 14px;}
    .btn div:nth-of-type(2){background-image: linear-gradient(to right, #FF6738, #FF4F36);color: #FFFFFF;font-size: 14px;}

    /* 撤单弹出框 */
    .confirmbox{border-top-left-radius: 12px;border-top-right-radius: 12px;background-color: #FFFFFF;position: fixed;bottom: 0;left: 0;right: 0;margin: 0 auto;z-index: 888}
    .confirmbox .title{text-align: center;padding: 17.67px 0 20.33px 0;color: #333333;font-size: 16px;display: flex;justify-content: center;font-weight: bold;}
    .confirmbox p{padding: 0 33.33px 36.33px 20.67px;color: #333333;font-size: 14px;text-align: left;}
    .confirmbox ul{height: 44px;padding: 0 20px 49px 20px;display: flex;justify-content: space-between;align-items: center;}
    .confirmbox ul li{border-radius: 22px;display: flex;justify-content: center;align-items: center;font-weight: bold;font-size: 16px;}
    .confirmbox ul li:nth-of-type(1){width: 49%;height: 100%;background-color: #EEEEEE;color: #333333;}
    .confirmbox ul li:nth-of-type(2){width: 49%;height: 100%;background-image: linear-gradient(to right, #FF4F36, #FF6738);color: #FFFFFF;}

    .revise{width: 100%;height: 1000px;position: fixed;top: 0;left: 0;z-index: 9997;background-color: #F5F5F5;}
    .revise .title{height: 44px;padding: 0 15px;display: flex;justify-content: space-between;align-items: center;}
    .revise .title img{width: 24px;height: 24px;display: block;}
    .revise .title p:nth-of-type(1){font-size: 16px;color: #333333;font-weight: bold;}
    .revise .title p:nth-of-type(2){font-size: 14px;color: #333333;}

    .revise-content{background-color: #FFFFFF;}
    .revise-content .tips{padding: 17px 0 7.33px 15px;color: #BBBBBB;font-size: 12px;}

    .revise-item{height: 44px;padding: 0 15px;display: flex;justify-content: space-between;align-items: center;border-bottom: 1px solid #EEEEEE;}
    .revise-item p:nth-of-type(1){color: #333333;font-size: 14px;display: flex;align-items: center;justify-content: flex-start;flex: 1;}
    .revise-item p:nth-of-type(1) span{color: #999999;font-size: 12px;padding-left: 8.33px;}
    .revise-item p:nth-of-type(2){color: #333333;font-size: 14px;font-weight: bold;display: flex;align-items: center;text-align: right;flex: 1;justify-content: flex-end;}
    .revise-item p:nth-of-type(2) span{color: #999999;font-size: 14px;}
    .revise-item p:nth-of-type(2) .icon-right{width: 16px;height: 16px;display: block;}
    .cut{width: 22px;height: 22px;display: block;margin-right: 10px;}
    .add{width: 22px;height: 22px;display: block;margin-left: 10px;}
    input{text-align: center;width: 34%;outline: none;border: none;}

    .revise-item .price-up{width: 16px;height: 16px;display: block;margin-left: 12.67px;transition: all 0.5s;}
    .revise-item .jiage{width: 50px;height: 20px;font-size: 12px !important;display: flex;justify-content: center;align-items: center;border-top-left-radius: 11px;border-bottom-left-radius: 11px;border-top-right-radius: 0;border-bottom-right-radius: 0;}
    .revise-item .dianshu{width: 50px;height: 20px; font-size: 12px !important;display: flex;justify-content: center;align-items: center;border-top-right-radius: 11px;border-bottom-right-radius: 11px;border-top-left-radius: 0;border-bottom-left-radius: 0;}

    .sliderdown-item{height: 44px;padding: 0 15px;display: flex;justify-content: space-between;align-items: center;border-bottom: 1px solid #EEEEEE;}
    .sliderdown-item p:nth-of-type(1){color: #333333;font-size: 14px;display: flex;align-items: center;justify-content: flex-start;flex: 1;}
    .sliderdown-item p:nth-of-type(1) span{color: #999999;font-size: 12px;padding-left: 8.33px;}
    .sliderdown-item p:nth-of-type(2){color: #333333;font-size: 14px;font-weight: bold;display: flex;align-items: center;text-align: right;flex: 1;justify-content: flex-end;}
    .sliderdown-item p:nth-of-type(2) span{color: #999999;font-size: 14px;padding-left: 5px;}
    .sliderdown-item p:nth-of-type(2) .icon-right{width: 16px;height: 16px;display: block;}

    .active{display: block;width: 36px;height: 22px;border-radius: 9px;color: #FF4F36 !important; text-align: center;line-height: 18px;border: none;background-color: #FFEDEA !important;}
    .actived{display: block;width: 36px;height: 20px;border-radius: 9px;text-align: center;line-height: 18px;}
    
    /* 修改撤单按钮 */
    .reviseBtn{padding: 15px 15px 270px 15px;display: flex;justify-content: space-between;align-items: center;}
    .reviseBtn p:nth-of-type(1){width: 48.3%;height: 44px;color: #333333;font-size: 16px;border-radius: 22px;background-color: #EEEEEE;text-align: center;line-height: 44px;font-weight: bold;}
    .reviseBtn p:nth-of-type(2){width: 48.3%;height: 44px;color: #FFFFFF;font-size: 16px;border-radius: 22px;background-image: linear-gradient(to right, #FF4F36,#FF6738);text-align: center;line-height: 44px;font-weight: bold;}

    /* 选择交易日期 */
    .databox{border-top-left-radius: 12px;border-top-right-radius: 12px;background-color: #FFFFFF;position: fixed;left: 0;right: 0;bottom: 0;z-index: 9999999999999999999;padding-bottom: 30px;}
    .databox .title{text-align: center;padding: 17px 0;font-weight: bold;}
    .databox .title .close{width: 24px;height: 24px;display: block;position: absolute;left: 15.33px;top: 13px;}
    .databox .datelist{padding-left: 20.33px}
    .databox .datelist .item{border-bottom: 1px solid #F5F5F5;height: 45px;display: flex;justify-content: space-between;align-items: center;color: #333333;font-size: 16px;}
    .databox .datelist .item img{width: 24px;height: 24px;display: block;margin-right: 15px;}

    /*通过fixed固定mescroll的高度*/
	.mescroll {position: fixed;top: 82px;bottom: 0;height: auto;z-index: 885;}
</style>


// WEBPACK FOOTER //
// src/pages/pendingOrder.vue